import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { AuthService } from '../../core/services/auth.service';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, FormsModule, RouterModule],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  searchQuery = '';
  userName = 'Admin';
  userRole = 'Admin';
  currentUserId: string | null = null;
  showUserMenu = false;
  notificationCount = 3;
  accounts: any[] = [];

  constructor(private authService: AuthService, private router: Router) {}

  ngOnInit(): void {
    this.authService.currentUser$.subscribe(user => {
      if (user) {
        this.userName = user.name || 'Admin';
        this.userRole = user.role || 'Admin';
        this.currentUserId = user.id;
      }
      this.accounts = this.authService.getStoredAccounts();
    });
  }

  toggleUserMenu(): void {
    this.showUserMenu = !this.showUserMenu;
  }

  switchAccount(userId: string): void {
    if (userId !== this.currentUserId) {
      this.authService.switchAccount(userId);
    }
  }

  addAccount(): void {
    this.router.navigate(['/login'], { queryParams: { add_account: 'true' } });
  }

  logout(): void {
    this.authService.logout();
  }
}
